import Splide from '@splidejs/splide';

const durationAnim = 1;
const pourcentage = 45;
const total = 360;
const strokeDasharray = ((pourcentage * total) / 100);


export default class HeroSlider {
	static init() {
		Array.from(document.querySelectorAll('.hero-slider-splide')).forEach(element => {
			new HeroSlider(element);
		});

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            window.addEventListener('click', (e) => {
                if(!e.target.closest('.hero-slider')) {
                    return;
                }
                document.querySelector('.hero-slider-editable').classList.toggle('is-hidden');
            });
        }
	}

	constructor(element) {
		const options = {
			type: 'fade',
			arrows: false,
			rewind: true,
			speed: 1400 * durationAnim,
			autoplay: true,
			pauseOnHover: false,
			interval: 5000,
			throttle: 1000,
			keyboard: 'true',
			perPage: 1,
			gap: '0',
			resetProgress: false,
		};

        switch(document.documentElement.lang) {
            case 'de':
                options.i18n = {
                    prev: 'Vorheriger Artikel',
                    next: 'Nächster Artikel',
                    first: 'Gehe zum ersten Artikel',
                    last: 'Gehe zum letzten Artikel',
                    slideX: 'Gehe zu Artikel %s',
                    pageX: 'Gehe zu Seite %s',
                    play: 'Autoplay starten',
                    pause: 'Autoplay pausieren',
                }
                break;
            case 'it':
                options.i18n = {
                    prev: 'Articolo precedente',
                    next: 'Prossimo articolo',
                    first: 'Vai al primo articolo',
                    last: 'Vai all\'ultimo articolo',
                    slideX: 'Vai all\'articolo %s',
                    pageX: 'Vai alla pagina %s',
                    play: 'Avvia autoplay',
                    pause: 'Metti in pausa autoplay',
                }
                break;
            default:
                options.i18n = {
                    prev: 'Previous article',
                    next: 'Next article',
                    first: 'Go to first article',
                    last: 'Go to last article',
                    slideX: 'Go to article %s',
                    pageX: 'Go to page %s',
                    play: 'Start autoplay',
                    pause: 'Pause autoplay',
                };
        }

        this.element = element;
		this.splide = new Splide(element, options).mount();
		this.splide.on('active', (e) => this.active(e));
		this.splide.on('inactive', (e) => this.inactive(e));
		this.splide.on('moved', (newIndex, prevIndex, destIndex) => this.movedEnd(newIndex, prevIndex, destIndex));
        this.splide.on( 'autoplay:play', () => element.classList.add('hero-slider-splide--is-autoplaying'));
        this.splide.on( 'autoplay:pause', () => element.classList.remove('hero-slider-splide--is-autoplaying'));
		this.splideMount();

        /** this is the accessibility view for the slider */
        this.element.querySelector('.hero-slider__list-view-button').addEventListener('click', (e) => this.element.parentElement.classList.add('hero-slider--is-list-view'));
        this.element.parentElement.querySelector('.hero-slider__slide-view-button').addEventListener('click', (e) => this.element.parentElement.classList.remove('hero-slider--is-list-view'));
	}


	splideMount() {
		this.updatePagination(0);

		let allSlideHeadlines = this.splide.root.querySelectorAll('.slide-data h2');
		let firstSlide = this.splide.Components.Elements.list.children[0];
		if (!firstSlide) {
			return;
		}
		let firstSlideHeadline = firstSlide.querySelectorAll('.slide-data h2');
		gsap.set(allSlideHeadlines, {opacity: 0});
		gsap.set(firstSlideHeadline, {opacity: 1});

		const customPagers = Array.from(document.querySelectorAll('.splide__custom__pagination li'));
		customPagers.forEach((item, index) => {
			item.addEventListener('click', (event) => {
				this.splide.go(index);
			});
		});
	}

	active(e) {
		const slide = e.slide;
		const imgBox = slide.querySelectorAll('.slide-img-box');
		const slidTitle = slide.querySelectorAll('h2');
		gsap.fromTo(
			imgBox,
			{ /* xPercent: 100, autoAlpha: 1 */ clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)'},
			{
				duration: durationAnim,
				ease: 'power4.out', /* xPercent: 0, autoAlpha: 1 */
				clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
				clearProps: 'clipPath'
			},
		);
		gsap.fromTo(
			imgBox,
			{scale: 1.35},
			{duration: durationAnim, ease: 'power4.out', scale: 1},
		);
		gsap.fromTo(
			slidTitle,
			{x: 25, opacity: 0},
			{
				duration: durationAnim / 2,
				ease: 'power4.out',
				x: 0,
				opacity: 1,
				delay: durationAnim / 5,
				clearProps: true
			},
		);

		if (this.splide.index !== 0) {
			const prevSlide = slide.previousElementSibling;
			prevSlide.style.opacity = 1;
		}
	}

	inactive(e) {
		const splidTitle = e.slide.querySelectorAll('h2');
		gsap.to(splidTitle,{x: -25, opacity: 0, duration: durationAnim / 2, ease: 'power4.out'});
	}

	movedEnd(newIndex, prevIndex, destIndex) {
		this.updatePagination(newIndex);
		document.querySelector('.banner-section').dataset.color = this.splide.root.querySelectorAll('.splide__slide')[newIndex].dataset.color;
	}

	updatePagination(newIndex) {
		const slider_pagination = Array.from(this.splide.root.querySelectorAll('.splide__custom__pagination li'));
		slider_pagination.forEach((item, index) => {
			if (index === newIndex) {
				item.classList.add('actSlide');
				item.querySelector('.pie').style.strokeDasharray = strokeDasharray;
			} else {
				item.classList.remove('actSlide');
				item.querySelector('.pie').style.strokeDasharray = '';
			}
		});
	}
}
